module.exports = __webpack_public_path__ + "img/check.d77d3751.png";